import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// Silencia console.log en los builds de prod y beta; staging y desarrollo los mantienen
if (process.env.NODE_ENV !== "development" && process.env.REACT_APP_ENV !== "staging")
    console.log = () => {};